import {
  AUTO_LINK_LOGISTICS_ENDPOINT,
  DOWNLOAD_LOGISTICS_ENDPOINT,
  LOGISTICS_ENDPOINT,
  LOGISTICS_LINKBARCODE_ENDPOINT,
  LOGISTICS_LINKBOOK_ENDPOINT,
  LOGISTICS_UNLINKBARCODE_ENDPOINT,
  LOGISTICS_SAVE_MAP_ENDPOINT,
  LOGISTICS_DISABLE_ENDPOINT,
  LOGISTICS_CHANGE_HAS_RETURN_MARK,
  LOGISTICS_DUPLICATELINES_ENDPOINT,
  LOGISTICS_EXPORTPACKAGES_ENDPOINT,
  LOGISTICS_WARNINGS_ENDPOINT,
  LOGISTICS_STATISTICS_ENDPOINT,
  LOGISTICS_LINK_RETURN_ENDPOINT,
} from "../Constants/Endpoints";
import { apiCall, apiCallJson } from "../Helpers";
import { objectToQueryString } from "../Helpers/utils/utils";

export async function getLogisticsPackageByIdParams(id) {
  return await apiCallJson(LOGISTICS_ENDPOINT + `?id=${id}`, "GET", null);
}

export async function updateLogisticsParams() {
  return await apiCallJson(DOWNLOAD_LOGISTICS_ENDPOINT, "POST", null);
}

export async function autoLinkLogisticsParams() {
  return await apiCallJson(AUTO_LINK_LOGISTICS_ENDPOINT, "PUT", null);
}

export async function logisticsLinkToBarcodeParams(receiptId, barcodeId) {
  let params = {
    ReceipId: receiptId,
    BarcodeId: barcodeId,
  };
  return await apiCallJson(
    LOGISTICS_LINKBARCODE_ENDPOINT + objectToQueryString(params, true),
    "PUT",
    null
  );
}

export async function logisticsLinkToReturnParams(receiptId, barcodeReturnId) {
  let params = {
    ReceipId: receiptId,
    BarcodeReturnId: barcodeReturnId,
  };
  return await apiCallJson(
    LOGISTICS_LINK_RETURN_ENDPOINT + objectToQueryString(params, true),
    "PUT",
    null
  );
}

export async function logisticsUnlinkToBarcodeParams(receiptId) {
  let params = { ReceipId: receiptId };
  return await apiCallJson(
    LOGISTICS_UNLINKBARCODE_ENDPOINT + objectToQueryString(params, true),
    "PUT",
    null
  );
}

export async function logisticsLinkToBookParams(receiptId, barcodeBookId) {
  let params = {
    LineId: receiptId,
    BarcodeBookId: barcodeBookId,
  };
  return await apiCallJson(
    LOGISTICS_LINKBOOK_ENDPOINT + objectToQueryString(params, true),
    "PUT",
    null
  );
}

export async function putLogisticsSaveMapParams(receiptId, saved) {
  let params = {
    ReceipId: receiptId,
    saved: saved,
  };
  return await apiCallJson(
    LOGISTICS_SAVE_MAP_ENDPOINT + objectToQueryString(params, true),
    "PUT",
    null
  );
}

export async function putLogisticsDisableParams(receiptId, disabled) {
  let params = {
    ReceipId: receiptId,
    Disabled: disabled,
  };
  return await apiCallJson(
    LOGISTICS_DISABLE_ENDPOINT + objectToQueryString(params, true),
    "PUT",
    null
  );
}


export async function putLogisticsChangeStatus(receiptId) {
  let params = {
    ReceipId: receiptId
  };
  return await apiCallJson(
    LOGISTICS_CHANGE_HAS_RETURN_MARK + objectToQueryString(params, true),
    "PUT",
    null
  );
}

export async function duplicateLinesToNewReceip(receiptId) {
  let params = {
    ReceipId: receiptId,
  };
  return await apiCallJson(
    LOGISTICS_DUPLICATELINES_ENDPOINT + objectToQueryString(params, true),
    "PUT",
    null
  );
}

export async function exportPackages(schoolNumber, exportOnlyNews) {
  let params = {
    schoolNumber: schoolNumber,
    seeOnlyNews: exportOnlyNews,
  };

  let requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
  };

  return await apiCall(
    LOGISTICS_EXPORTPACKAGES_ENDPOINT + objectToQueryString(params, true),
    requestOptions,
    "export-logistic-receips"
  );
}

export async function getLogisticsWarnings(schoolNumber) {
  let params = {
    schoolNumber: schoolNumber,
  };

  return await apiCallJson(
    LOGISTICS_WARNINGS_ENDPOINT + objectToQueryString(params, true),
    "GET",
    null
  );
}

export async function getLogisticsStatisticsRequest(params) {
  return await apiCallJson(
    LOGISTICS_STATISTICS_ENDPOINT + objectToQueryString(params, true),
    "GET",
    null
  );
}
